import { Typography, Table, TableBody, TableRow, TableCell, Paper } from '@mui/material';
import colors from 'assets/theme/base/colors';
 
const MoreRegressionDetails = ({ regressionPerformance }: any) => {
    return (
        <Paper elevation={8} className="width-65"
        sx={{
            "&.MuiPaper-root": {
                padding: '16px !important',
                backgroundColor: `${colors.backgroundLight.dark} !important`,
            },
        }}
        >
            <Typography variant="h6" component="h6">
                More Details
            </Typography>
            {regressionPerformance && (
                <Table className="performance-overview-table">
                    <TableBody>
                        <TableRow>
                            <TableCell className="attrTitle" sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>Mean Absolute Error</TableCell>
                            <TableCell className="attrValue" sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>
                                {regressionPerformance['Mean Absolute Error']?.toFixed(6)}
                            </TableCell>
                            <TableCell className="attrTitle" sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>Root Mean Squared Log Error</TableCell>
                            <TableCell className="attrValue" title={regressionPerformance['Root Mean Squared Error']} sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>
                                {regressionPerformance['Root Mean Squared Error']?.toFixed(6)}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="attrTitle" sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>Mean Squared Error</TableCell>
                            <TableCell className="attrValue" title={regressionPerformance['Mean Squared Error']} sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>
                                {regressionPerformance['Mean Squared Error']?.toFixed(6)}
                            </TableCell>
                            <TableCell className="attrTitle" sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>R Squared Error</TableCell>
                            <TableCell className="attrValue" title={regressionPerformance['R Squared']} sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>
                                {regressionPerformance['R Squared']?.toFixed(6)}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className="attrTitle" sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>Root Mean Squared Error</TableCell>
                            <TableCell className="attrValue" title={regressionPerformance['Root Mean Squared Logarithmic Error']} sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}>
                                {regressionPerformance['Root Mean Squared Logarithmic Error']?.toFixed(6)}
                            </TableCell>
                            <TableCell className="attrTitle" sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}></TableCell>
                            <TableCell className="attrValue" sx={{ backgroundColor: `${colors.backgroundLight.dark} !important` }}></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            )}
        </Paper>
    );
};
 
export default MoreRegressionDetails;